export default __webpack_public_path__ + "static/media/app-autopass.4f052a68.svg";